const home = {
  heroTitle: 'Find your perfect stay in Urubici',
  heroSubtitle: 'Chalets, cabins and inns in Serra Catarinense',
  searchPlaceholder: 'Where do you want to go?',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  guests: 'Guests',
  searchButton: 'Search lodging',
  searchButtonShort: 'Search',
  featuredLodgings: 'Featured Lodging',
  viewAll: 'View all lodging',
  experiencesSection: 'Experiences',
  eventsSection: 'Events',
  faqTitle: 'Frequently Asked Questions',
  faqSubtitle: 'Clear answers about how it works',
  faq: {
    q1: 'How does the lodging search work?',
    a1: 'You browse the curated catalog, choose your lodging and contact them directly via WhatsApp, phone or official website. Reservation confirmation is handled directly with the establishment.',
    q2: 'Are prices updated in real time?',
    a2: 'No. The catalog shows available lodgings. For exact pricing and availability, contact the establishment directly through the published channels.',
    q3: 'Can I speak with the reservations center?',
    a3: 'Yes. Our center is available to assist with questions, recommendations and support during the selection process.',
    q4: 'Is this the official city website?',
    a4: 'Reserve Connect is a platform integrated with the municipal ecosystem, working in partnership with local hotels and the official city portal.',
  },
  centralSupport: 'Reservations Center',
  centralSupportDesc: 'Prefer to speak with a specialist? Our team is ready to help.',
  hero: {
    slide1: {
      title: 'Urubici, the winter you want to experience starts here',
      subtitle: 'True cold, mountains, nature and the best curated lodgings in the region.',
      cta: 'Search lodging',
    },
    slide2: {
      title: 'Book safely and choose with confidence',
      subtitle: 'Compare options, apply filters and contact establishments directly.',
      cta: 'Explore options',
    },
    slide3: {
      title: 'Urubici is roads, mountains and unforgettable experiences',
      subtitle: 'Motorcyclist hotspot, lush nature and high demand during special seasons.',
      cta: 'View lodging',
    },
    imageAlt: 'Tourist destination {{index}}',
  },
  searchForm: {
    destination: 'Destination',
    guestSingular: 'guest',
    guestPlural: 'guests',
  },
  catalogMicrocopy: 'Curated lodging catalog in Urubici. Direct contact with establishments.',
  trust: {
    item1: { title: 'Verified establishments', subtitle: 'Urubici Portal Curation' },
    item2: { title: 'Updated information', subtitle: 'Official catalog data' },
    item3: { title: 'Reservations center', subtitle: 'Support for your choice' },
  },
  featured: {
    label: 'Featured',
    subtitle: 'Selected options from Urubici curation',
    loadingMessage: 'Loading lodging...',
    errorMessage: 'Could not load lodging.',
    noResults: 'No lodging found with this filter.',
    contactAvailable: 'Direct contact available',
    viewDetails: 'View details',
    filters: ['All', 'Hotels', 'Inns', 'Houses', 'Chalets', 'Cabins'],
  },
  eventos: {
    title: 'Events & Seasons',
    subtitle: 'Plan your trip for the best moments in Urubici',
    card1: {
      title: 'Winter Season',
      description: 'True cold, occasional snow and unique mountain experiences',
      cta: 'View winter lodging',
    },
    card2: {
      title: 'Motorcycle Gathering',
      description: 'Traditional hotspot with scenic roads and full infrastructure',
      cta: 'Ideal lodging for motorcyclists',
    },
    card3: {
      title: 'Events & Festivals',
      description: 'Cultural festivals, gastronomic and local celebrations',
      cta: 'Search lodging for events',
    },
    card4: {
      title: 'Adventure Seasons',
      description: 'Trails, waterfalls and lush nature all year round',
      cta: 'View available lodging',
    },
  },
  explore: {
    title: 'Explore Urubici',
    subtitle: 'Everything you need to know to plan your trip',
    card1: {
      title: 'What to do',
      description: 'Discover attractions, tours and local experiences',
    },
    card2: {
      title: 'Best time to visit',
      description: 'Weather, events and tips on when to travel',
    },
    card3: {
      title: 'Complete city guide',
      description: 'History, culture and essential information',
    },
  },
  finalCta: {
    title: 'Ready to experience Urubici?',
    subtitle: 'Explore our curated catalog and find the perfect lodging for your trip.',
    button: 'View all lodging',
  },
};
export default home;
